import { useUser } from "@/features/auth/hooks/useUser";
import FullPageLoader from "@/ui/fullPageLoader/FullPageLoader";
import { AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME } from "@/utils/constants";
import { usePageTitle } from "@/i18n/usePageTitle";

import SubscriberHome from "./SubscriberHome";
import Landing from "@/pages/landing/Landing";

function Home() {
	usePageTitle("seo:titles.home");
	const { isLoggedIn, user, isPending } = useUser();

	// A logged-in user always has a token, so its absence proves there is no
	// session to wait for. Blocking the marketing page's first paint on
	// /auth/whoami/ costs an anonymous visitor up to ~15s on a flaky
	// connection (5s timeout, two retries) and wastes the prerendered shell.
	if (isPending && !localStorage.getItem(AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME))
		return <Landing mode="guest" />;
	if (isPending) return <FullPageLoader />;
	if (user?.is_subscribed) return <SubscriberHome />;

	return <Landing mode={isLoggedIn ? "free" : "guest"} />;
}

export default Home;
